import { useEffect, useState, useContext, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { CenterBox, OnsiteProgress } from "../../customelements/CustomInput";
import { HttpPostData, JumpPage } from "../../common/Util";
import { TitleParamContext } from "../../context/TitleContext";
import { LoginStateConext } from "../../context/AuthContext";
import { LicenseDatas, ResponseParamBase } from "../../common/Types";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

export type ResponseParam = ResponseParamBase & {
    list: LicenseDatas,
    hasTrial: boolean,
}

export type SubmitResponseParam = ResponseParamBase & {

}

export const AddTrialLicense = () => {

    const [product, setProduct] = useState<LicenseDatas>();
    const [hasTrial, sethasTrial] = useState<boolean>(false);
    const [isInitLoading, setIsInitLoading] = useState<boolean>(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState<boolean>(false);

    const titleContext = useContext(TitleParamContext);
    const loginState = useContext(LoginStateConext);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "お試しライセンス発行", secondSubTitle: "" });

            await HttpPostData<ResponseParam>("/License/GetTrialLicenseProduct", { "Email": "aaa" }, setIsInitLoading)
                .then((response) => {
                    console.log(response.data);
                    if (response.data.resultFlg) {
                        setProduct(response.data.list);
                        sethasTrial(response.data.hasTrial);
                    } else {
                        console.log(false);
                    }
                })
                .catch(e => { console.log(e) });
        })()
    }, []);

    function onSubmit(e: MouseEvent) {
        HttpPostData<ResponseParam>("/License/AddTrialLicense",
            {
                UserLicenses: product?.userLicenses.map((field, index) => {
                    return {
                        UserLicenseId: field.userLicenseId,
                        ProductMasterId: field.productId,
                        //PaymentContents: details.id,
                        PaymentContents: "",
                        Quantity: field.quantity,
                        NonTaxPrice: field.totalNonTaxPrice,
                        TaxPrice: field.totalTaxPrice,
                        IncludeTaxPrice: field.totalIncludeTaxPrice,
                        Licensekey: field.licenseKey,
                        StartLimit: field.startLimit,
                        EndLimit: field.endLimit,
                    }
                }),
                Email: loginState.loginInfo.email,
                PostCode: "",
                PhoneNumber: "",
                Address: "",
                CustomerName: "",
                Biko: "",
                DeliveryPrice: 0,
                DeliverySpan: 0,
                IsDelivery: false,
                PaypalCapturesId: "",
                PaypalResponseId: "",
            },
            setIsSubmitLoading,
        ).then((response) => {
            JumpPage("trialcomplete", { list: response.data.list }, "", navigate);
        })
    }

    return (
        <>
            {
                isInitLoading ?
                    <CenterBox>
                        <OnsiteProgress></OnsiteProgress>
                    </CenterBox>
                    :

                    <section className={market.marketArea}>
                        <div className={market.marketAreaInner}>
                            <section className={base.forPc} style={{ marginTop: "50px", marginBottom: "50px" }}>
                                <table className={base.pcTable} style={{ width: "70%" }}>
                                    <colgroup>
                                        <col width="30%" />
                                        <col width="70%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>ライセンス数</th>
                                            <th>お試し期間</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {product?.userLicenses.map((field, index) => {
                                            return (
                                                <tr>
                                                    <td>{field.quantity}</td>
                                                    <td>{field.limitSpanStr}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </section>
                            <section className={base.forSp} style={{ marginTop: "50px", marginBottom: "50px" }}>
                                <table className={base.spTable} style={{ width: "100%" }}>
                                    <colgroup>
                                        <col width="30%" />
                                        <col width="70%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>ライセンス数</th>
                                            <th>お試し期間</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {product?.userLicenses.map((field, index) => {
                                            return (
                                                <tr>
                                                    <td>{field.quantity}</td>
                                                    <td>{field.limitSpanStr}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </section>
                            <div className={base.centerContents}>
                                <p className={base.errorMessage}>
                                    {hasTrial ?
                                        "既にお試しライセンスを発行済みです。"
                                        :
                                        ""
                                    }
                                </p>
                            </div>
                            <div className={market.marketFooterArea}>
                                <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                                <button className={market.marketButton} type="button" disabled={hasTrial || isSubmitLoading} onClick={(e) => { onSubmit(e); }}>発行</button>
                                <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                            </div>
                        </div>
                    </section>
            }
        </>
    )
}